import React, {useContext, useState, useEffect, useRef} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import TextsContext from "../../TextsContent";
import "../WaterChallenge/waterChallenge.css";
import "./waterChallengeOpen.css";
import Routes from "../../assets/RoutesToPages/Routes";
import WorkoutPopupMessage from "../../components/WorkoutPopupMessage/WorkoutPopupMessage";
import ServerRequest from "../../ServerRequests/ServerRequest";

const WaterChallengeOpen = () => {
  const userID = localStorage.getItem("userHash");
  const navigate = useNavigate();
  const texts = useContext(TextsContext);
  const location = useLocation();
  let {
    choicedChallenge,
    chosenChallengeDaysAmount,
    allChallenges
  } = location.state || {};
  console.log(choicedChallenge)
  let chosenAutocompletedChallenge = choicedChallenge.concat('Autocompleted');
  let currentDay = Date.now();
  const [isPopupShown, setIsPopupShown] = useState(false);
  const [popupMessage, setIsPopupMessage] = useState(texts.water[choicedChallenge]["popup_text"]);
  const [popupCloseLink, setPopupCloseLink] = useState(Routes.waterBalance);
  const today = new Date().toISOString().split("T")[0];
  let userData = JSON.parse(localStorage.getItem(userID));
  const savedData = userData.waterBalanceData;
  // Get challenge status from localStorage
  const challengeStatus =
    JSON.parse(localStorage.getItem("challengeStatus")) || {};
  let [currentProgressFromCalendar, setCurrentProgressFromCalendar] = useState(chosenChallengeDaysAmount || 0);
  let chosenChallengeStatus = choicedChallenge.concat('Status');
  let chosenChallengeStatusDaily = choicedChallenge.concat('StatusDaily');
  const lastCompletedDate = challengeStatus[chosenChallengeStatusDaily];
  let isNeedAutocomplete =
    JSON.parse(localStorage.getItem("autocomplete_challenges"))[
      chosenAutocompletedChallenge
      ] || false;
  console.log(isNeedAutocomplete)
  // Determine if the challenge can be repeated
  let isChallengeCompletedToday = lastCompletedDate === today;
  const challengeNullishData = JSON.parse(localStorage.getItem('challengeNullishValue')) ?? null;
  localStorage.setItem('chosenChallengeStatus', JSON.stringify(
    {
      [chosenChallengeStatus]: challengeNullishData ?
        challengeNullishData[chosenChallengeStatus] : false,
    }
  ));
  let isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun'));
  localStorage.setItem('chosenChallengeStatusBegun', JSON.stringify({
    [chosenAutocompletedChallenge]: isChosenChallengeStatus[chosenAutocompletedChallenge]
  }));
  const chosenChallengeProgressType = choicedChallenge.concat('ChallengeProgressType');
  let challengeAutoUpdating = JSON.parse(localStorage.getItem('challengeAutoUpdating'));
  localStorage.setItem('chosenChallengeAutoUpdating', JSON.stringify({
    [chosenChallengeProgressType]: challengeAutoUpdating[chosenChallengeProgressType]
  }));
  const challengeOpenContainerRef = useRef(null);
  const timerFadeIn = useRef(null);
  const challengeOpenProgressBtnRef = useRef(null);


  useEffect(() => {
    if (challengeOpenContainerRef.current) {
      challengeOpenContainerRef.current.classList.add('challenge-open-container-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      challengeOpenContainerRef.current.classList.remove('challenge-open-container-fade-in');
    }, 350);

    window.scrollTo({top: 0, behavior: 'smooth'});

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  function getMillisecondsUntilTomorrow() {
    const now = new Date();
    const tomorrow = new Date(now);
    // Встановлюємо завтрашній день
    tomorrow.setUTCDate(now.getUTCDate() + 1);
    // Скидаємо години, хвилини, секунди і мілісекунди
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow.getTime();
  }


  // Створення масиву чисел від 1 до 10
  const days = Array.from({length: 10}, (_, i) => i + 1);


  // Функція для збільшення прогресу
  const addProgress = () => {
    const newCurrenProgressFromCalendar = currentProgressFromCalendar + 1;
    if (currentProgressFromCalendar < days.length) {
      localStorage.setItem(
        "challengeStatus",
        JSON.stringify({
          ...challengeStatus,
          [chosenChallengeStatusDaily]: today,
        })
      );
      const challengeStatusUpdated = JSON.parse(localStorage.getItem("challengeStatus")) || {};
      localStorage.setItem('chosenChallengeStatusDaily', JSON.stringify({
        [chosenChallengeStatusDaily]: challengeStatusUpdated[chosenChallengeStatusDaily],
      }));

      setCurrentProgressFromCalendar(newCurrenProgressFromCalendar);

      if (newCurrenProgressFromCalendar > 0) {
        const challengeNullishData = JSON.parse(localStorage.getItem('challengeNullishValue')) ?? null;
        let challengeNullishValue = challengeNullishData ?? allChallenges;
        challengeNullishValue = {
          ...challengeNullishValue,
          [chosenChallengeStatus]: false,
        }

        localStorage.setItem('chosenChallengeStatus', JSON.stringify(
          {
            [chosenChallengeStatus]: false,
          }
        ));

        localStorage.setItem('challengeNullishValue', JSON.stringify(challengeNullishValue));
      }
    }
  };

  useEffect(() => {
    if (challengeOpenProgressBtnRef.current && currentProgressFromCalendar < days.length) {
      challengeOpenProgressBtnRef.current.classList.add('clicked-active');

      setTimeout(() => {
        challengeOpenProgressBtnRef.current.classList.remove('clicked-active');
      }, 305);
    }
  }, [currentProgressFromCalendar]);


  const waterChallengeContent = [
    {
      id: 1,
      image: require("../WaterChallenge/img/calm.png"),
      description: texts.water[choicedChallenge]["calm_text"],
    },
    {
      id: 2,
      image: require("../WaterChallenge/img/flower.png"),
      description: texts.water[choicedChallenge]["flower_text"],
    },
    {
      id: 3,
      image: require("../WaterChallenge/img/star.png"),
      description: texts.water[choicedChallenge]["star_text"],
    },
    {
      id: 4,
      image: require("../WaterChallenge/img/butterfly.png"),
      description: texts.water[choicedChallenge]["butterfly_text"],
    },
  ];


  const handleFinish = () => {
    const updatedAutocompletedChallenges = JSON.parse(localStorage.getItem('autocomplete_challenges'));
    localStorage.setItem("autocomplete_challenges", JSON.stringify({
      ...updatedAutocompletedChallenges,
      [chosenAutocompletedChallenge]: false,
    }));

    const challengeAutoUpdating = JSON.parse(localStorage.getItem('challengeAutoUpdating'));
    localStorage.setItem("challengeAutoUpdating", JSON.stringify({
      ...challengeAutoUpdating,
      [chosenChallengeProgressType]: false,
    }));

    localStorage.setItem("chosenChallengeAutoUpdating", JSON.stringify({
      [chosenChallengeProgressType]: false,
    }));

    localStorage.setItem('challengeStatus', JSON.stringify({
      ...challengeStatus,
      [chosenChallengeStatusDaily]: '1970-01-01'
    }));

    localStorage.setItem("chosenChallengeStatusDaily", JSON.stringify({
      [chosenChallengeStatusDaily]: '1970-01-01',
    }));

    const challengeNullishData = JSON.parse(localStorage.getItem('challengeNullishValue')) ?? null;
    let challengeNullishValue = challengeNullishData ?? allChallenges;

    setCurrentProgressFromCalendar(0);
    challengeNullishValue = {
      ...challengeNullishValue,
      [chosenChallengeStatus]: true,
    }

    localStorage.setItem('chosenChallengeStatus', JSON.stringify(
      {
        [chosenChallengeStatus]: false,
      }
    ));

    localStorage.setItem('isBegun', JSON.stringify(
      {
        ...isChosenChallengeStatus,
        [chosenAutocompletedChallenge]: false
      }
    ));

    localStorage.setItem('chosenChallengeStatusBegun', JSON.stringify(
      {
        [chosenAutocompletedChallenge]: false,
      }
    ));

    localStorage.setItem('challengeNullishValue', JSON.stringify(challengeNullishValue));
    navigate(Routes.waterBalance);
  };


  useEffect(() => {
    const challengeNullishData = JSON.parse(localStorage.getItem('challengeNullishValue')) ?? null;
    let challengeNullishValue = challengeNullishData ?? allChallenges;

    if (currentProgressFromCalendar === days.length) {
      setIsPopupShown(true);
      currentDay = Date.now();
      setCurrentProgressFromCalendar(days.length);

      let msToNextDay = getMillisecondsUntilTomorrow();
      // const msToNextDay = 1743578000000;
      let savedMsToNextDay = localStorage.getItem(`msToNextDay${choicedChallenge}`);
      let nextDayStarting = savedMsToNextDay ?? getMillisecondsUntilTomorrow();
      // let nextDayStarting = savedMsToNextDay ?? 1743578000000;

      if (currentDay >= nextDayStarting) {
        setCurrentProgressFromCalendar(0);
        challengeNullishValue = {
          ...challengeNullishValue,
          [chosenChallengeStatus]: true,
        }

        localStorage.setItem('chosenChallengeStatus', JSON.stringify(
          {
            [chosenChallengeStatus]: false,
          }
        ));

        localStorage.setItem('isBegun', JSON.stringify(
          {
            ...isChosenChallengeStatus,
            [chosenAutocompletedChallenge]: false
          }
        ));

        localStorage.setItem('chosenChallengeStatusBegun', JSON.stringify(
          {
            [chosenAutocompletedChallenge]: false,
          }
        ));

        localStorage.setItem('challengeNullishValue', JSON.stringify(challengeNullishValue));

        const updatedAutocompletedChallenges = JSON.parse(localStorage.getItem('autocomplete_challenges'));
        localStorage.setItem("autocomplete_challenges", JSON.stringify({
          ...updatedAutocompletedChallenges,
          [chosenAutocompletedChallenge]: false,
        }));

        localStorage.setItem('challengeStatus', JSON.stringify({
          ...challengeStatus,
          [chosenChallengeStatusDaily]: '1970-01-01'
        }));

        localStorage.setItem(`isNeedToClearMsToNextDay${choicedChallenge}`, true);
      }

      if (!savedMsToNextDay) {
        localStorage.setItem(`msToNextDay${choicedChallenge}`, msToNextDay);
      }

      if (localStorage.getItem(`isNeedToClearMsToNextDay${choicedChallenge}`)) {
        localStorage.removeItem(`msToNextDay${choicedChallenge}`);
        localStorage.removeItem(`isNeedToClearMsToNextDay${choicedChallenge}`);
      }
    }

  }, [currentProgressFromCalendar]);


  useEffect(() => {
    const localChosenChallengeStatus = JSON.parse(localStorage.getItem('chosenChallengeStatus'));
    const localChosenChallengeStatusKey = Object.keys(localChosenChallengeStatus)[0];
    const localChosenChallengeStatusValue = Object.values(localChosenChallengeStatus)[0];
    const localChosenChallengeStatusDaily = JSON.parse(localStorage.getItem('chosenChallengeStatusDaily'));
    const localChosenChallengeStatusDailyKey = localChosenChallengeStatusDaily ?
      Object.keys(localChosenChallengeStatusDaily)[0] : null;
    const localChosenChallengeStatusDailyValue = localChosenChallengeStatusDaily ?
      Object.values(localChosenChallengeStatusDaily)[0] : null;
    const localChallengeStatusBegun = JSON.parse(localStorage.getItem('chosenChallengeStatusBegun'));
    const localChallengeStatusBegunKey = Object.keys(localChallengeStatusBegun)[0];
    const localChallengeStatusBegunValue = Object.values(localChallengeStatusBegun)[0];
    const localChallengeAutoUpdating = JSON.parse(localStorage.getItem('chosenChallengeAutoUpdating'));
    const localChallengeAutoUpdatingKey = Object.keys(localChallengeAutoUpdating)[0];
    const localChallengeAutoUpdatingValue = Object.values(localChallengeAutoUpdating)[0];

    // Оновити або додати запис для поточної дати
    const updatedCurrentProgressData = savedData.map((entry) =>
      (entry.date === today && localChosenChallengeStatusDaily !== null)
        ? {
          ...entry,
          [choicedChallenge]: currentProgressFromCalendar,
          [localChosenChallengeStatusKey]: localChosenChallengeStatusValue,
          [localChosenChallengeStatusDailyKey]: localChosenChallengeStatusDailyValue,
          [localChallengeStatusBegunKey]: localChallengeStatusBegunValue,
          [localChallengeAutoUpdatingKey]: localChallengeAutoUpdatingValue,
        } :
        entry.date === today ? {
          ...entry,
          [choicedChallenge]: currentProgressFromCalendar,
          [localChosenChallengeStatusKey]: localChosenChallengeStatusValue
        } : entry
    );

    userData["waterBalanceData"] = [...updatedCurrentProgressData];
    localStorage.setItem(userID, JSON.stringify(userData));

    const currentUserData = JSON.parse(localStorage.getItem(userID));
    const currentSavedData = currentUserData.waterBalanceData;
    let allChallenges = JSON.parse(localStorage.getItem('challengeNullishValue'));
    const allChallengesStatusDaily = JSON.parse(localStorage.getItem('challengeStatus'));
    const allChallengesStatusBegun = JSON.parse(localStorage.getItem('isBegun'));

    const sendWaterBalanceData = async () => {
      const todayWaterBalanceData = currentSavedData
        ? currentSavedData.find((item) => {
          return item.date === new Date().toISOString().split("T")[0];
        })
        : null;

      try {
        if (todayWaterBalanceData) {
          await ServerRequest.sendWaterBalanceData
          (
            challengeAutoUpdating,
            allChallengesStatusBegun,
            allChallengesStatusDaily,
            allChallenges,
            todayWaterBalanceData,
            userID
          );
        }
      } catch (error) {
        console.error("Error sending user response by workout:", error);
      }
    };

    (async () => {
      await sendWaterBalanceData();
    })();
  }, [currentProgressFromCalendar]);


  return (
    <>
      <div ref={challengeOpenContainerRef}
           className="main-container water-challenge">
        <div className="outer-content">
          <img
            className="main-logo"
            alt="logo"
            src={require("../../assets/img/avo-bottle.png")}
          />
          <p className="main-text">{texts.water["main-text"]}</p>
        </div>
        <div className="inner-content">
          <div className="workout-navigation">
            <img
              className="workout-navigation__arrow"
              onClick={() => isChosenChallengeStatus[chosenAutocompletedChallenge] ?
                navigate(Routes.waterBalance) : navigate(0)}
              src={require("../../assets/img/back_arrow.svg").default}
              width="24"
              height="24"
              alt="image arrow left"
            ></img>
            <h2 className="water-challenge__title">
              {texts.water[choicedChallenge]["opened_box_title"]}
            </h2>
          </div>

          <div className="water-challenge_progress">
            {days.map((day) => (
              <div
                key={day}
                className={`water-day ${day <= currentProgressFromCalendar ? "done" : ""}`}
              >
                {day}
              </div>
            ))}
          </div>
          {currentProgressFromCalendar === days.length ? null : !isNeedAutocomplete ? (
            <div ref={challengeOpenProgressBtnRef}
                 onClick={addProgress}
                 className={`water-challenge_add_progress ${
                   isChallengeCompletedToday ? "disabled" : ""
                 }`}
            >
              <img className='challenge-open-plus'
                   src={require('./img/icon-plus.svg').default}
                   alt="icon plus"
                   width={24}
                   height={24}/>
              <strong className='challenge-open-progress-text'>
                {texts.water["one-day-progress"]}
              </strong>
            </div>
          ) : null}
          <div className="water-challenge__content">
            {waterChallengeContent
              .filter(
                (item) => item.description && item.description.trim() !== "")
              .map((waterChallengeContentItem) => (
                <div
                  key={waterChallengeContentItem.id}
                  className="water-challenge__item"
                >
                  <div className="water-challenge__item-icon">
                    <img src={waterChallengeContentItem.image} alt="text icon"/>
                  </div>
                  <p className="water-challenge__item-description challenge-open">
                    {waterChallengeContentItem.description}
                  </p>
                </div>
              ))}
          </div>

          {currentProgressFromCalendar < 10 ?
            <button className="water-challenge_start challenge-open-start" onClick={() => navigate(Routes.waterBalance)}>
              {texts.water["finish"][0]}
            </button> :
            <button className="water-challenge_start" onClick={handleFinish}>
              {texts.water["finish"][1]}
            </button>
          }
        </div>
      </div>

      {isPopupShown ? (
        <WorkoutPopupMessage
          isShown={isPopupShown}
          message={popupMessage}
          redirectLink={popupCloseLink}
        />
      ) : null}
    </>
  );
};

export default WaterChallengeOpen;